import { useRef, useEffect } from 'react'
import { Image } from 'react-konva'
import Konva from 'konva'
import { TileData } from '../types'

interface TileProps {
  tile: TileData
  tileWidth: number
  tileHeight: number
  onDragStart: (tileId: string) => void
  onDragEnd: (tileId: string, x: number, y: number) => void
  onDragMove: (tileId: string, x: number, y: number) => void
  isInMergedGroup?: boolean
}

function Tile({
  tile,
  tileWidth,
  tileHeight,
  onDragStart,
  onDragEnd,
  onDragMove,
  isInMergedGroup = false,
}: TileProps) {
  const imageRef = useRef<Konva.Image>(null)

  useEffect(() => {
    // Force redraw when image changes
    if (imageRef.current) {
      imageRef.current.cache()
    }
  }, [tile.imageData])

  return (
    <Image
      ref={imageRef}
      x={tile.currentPosition.x}
      y={tile.currentPosition.y}
      width={tileWidth}
      height={tileHeight}
      image={tile.imageData}
      crop={{
        x: tile.sourceX,
        y: tile.sourceY,
        width: tile.sourceWidth,
        height: tile.sourceHeight,
      }}
      draggable={!isInMergedGroup}
      shadowBlur={5}
      shadowColor="rgba(0,0,0,0.3)"
      shadowOffsetX={2}
      shadowOffsetY={2}
      onDragStart={(e) => {
        e.target.moveToTop()
        onDragStart(tile.id)
      }}
      onDragMove={(e) => onDragMove(tile.id, e.target.x(), e.target.y())}
      onDragEnd={(e) => onDragEnd(tile.id, e.target.x(), e.target.y())}
      onMouseEnter={(e) => {
        const container = e.target.getStage()?.container()
        if (container) {
          container.style.cursor = 'grab'
        }
      }}
      onMouseLeave={(e) => {
        const container = e.target.getStage()?.container()
        if (container) {
          container.style.cursor = 'default'
        }
      }}
      onTouchStart={() => onDragStart(tile.id)}
    />
  )
}

export default Tile
